// build dev
// const serverCore = 'https://core-dev.globalcare.vn/';

//build beta
// const serverCore = 'https://core-beta.globalcare.vn/';


// build live
// const serverCore = 'https://core.globalcare.vn/';

// // build dev
const serverOpen = 'https://open-api-dev.globalcare.vn/';
const nodeEnv = 'development';

// build live
// const serverOpen = 'https://open-api.globalcare.vn/';
// const nodeEnv = 'production';

export {
    serverOpen,
    nodeEnv
};